import { DateTime } from 'luxon'
import { Locale } from '@/root/shared-types'
import { dateFormats } from '@/root/shared-consts'

const { FULL_DATE, SIMPLE_TIME } = dateFormats

interface formatDateTimeParams {
  dateTimeISO: string
  locale: Locale
  warning: string
}

interface FormattedDateTime {
  date: string
  time: string
}

export const formatDateTime = ({ dateTimeISO, locale, warning }: formatDateTimeParams): FormattedDateTime => {
  const parsedDateTime = DateTime.fromISO(dateTimeISO)

  if (!parsedDateTime.isValid) {
    return { date: warning, time: '' }
  }

  const date = parsedDateTime.setLocale(locale).toFormat(FULL_DATE)
  const time = parsedDateTime.toFormat(SIMPLE_TIME)

  return { date, time }
}
